import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const {
	colors,
	spacing: { xs, sm, md, xl },
	typography: { fontSizes, fontWeights },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		padding: xl,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: xl,
		justifyContent: 'space-between',
	},

	section: {
		gap: md,
		flex: '0 0 auto',
	},

	sectionTitle: {
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		color: colors.text.dark,
		margin: `0 0 ${md} 0`,
	},

	sectionSubTitle: {
		fontSize: fontSizes.md,
		fontWeight: fontWeights.bold,
		color: colors.text.dark,
		margin: '0',
	},

	sectionDescription: {
		fontSize: fontSizes.sm,
		color: colors.text.main,
		lineHeight: '1.4',
		margin: '0',
	},

	columnList: {
		gap: sm,
		marginTop: xs,
	},

	columnGroup: {
		gap: sm,
	},

	groupLabel: {
		fontSize: fontSizes.sm,
		fontWeight: fontWeights.bold,
		color: colors.text.dark,
		textTransform: 'uppercase',
		letterSpacing: '0.04em',
		margin: `${md}px 0 0 0`,
	},

	columnItem: {
		alignItems: 'flex-start',
		padding: `${xs} 0`,
	},

	columnLabelContainer: {
		gap: xs,
		marginLeft: xs,
	},

	columnLabel: {
		fontSize: fontSizes.sm,
		color: colors.text.dark,
		margin: '0',
	},

	requiredIndicator: {
		fontSize: fontSizes.sm,
		color: colors.text.main,
		fontStyle: 'italic',
		margin: '0',
	},

	limitMessage: {
		fontSize: fontSizes.xs,
		color: colors.text.light,
		fontStyle: 'italic',
		margin: '0',
	},

	footer: {
		gap: md,
		paddingTop: xl,
		borderTop: `1px solid ${colors.border.light}`,
		minHeight: 100,
	},

	footerStats: {
		justifyContent: 'center',
	},

	statsText: {
		fontSize: fontSizes.xs,
		color: colors.text.main,
		margin: '0',
	},

	resetButton: {
		alignSelf: 'center',
	},
});
